module.exports = __webpack_public_path__ + "img/research_3.5bc95af3.png";